import { createStyles, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Button, Dialog, Icons, Typography } from '@nutrien/cxp-components';
import dayjs from 'dayjs';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useHistory } from 'react-router-dom';

import { useMst } from '../../mobx-models/Root';
import { ApiStatus } from '../../utilities/enums';
import { useAIMSHeartbeat } from '../../utilities/hooks/useAIMSHeartbeat';
import SiteDisciplinePopUp from '../SiteDisciplinePopUp/SiteDisciplinePopUp';

const useStyles = makeStyles(() => {
  return createStyles({
    root: {
      height: '100vh',
    },
    card: {
      margin: '80px auto',
      textAlign: 'center',
    },
    text: {
      marginTop: '20px',
    },
    actionGrid: {
      padding: '8px 16px 8px 8px',
      '& .logoutButton': { width: '91px', height: '44px' },
    },
    dialogContent: {
      marginBottom: 23,
      marginTop: 31,
    },
  });
});

const Home = () => {
  const classes = useStyles();
  const { primaryContext } = useMst();
  const history = useHistory();
  const { sendAIMSHeartbeat } = useAIMSHeartbeat();

  return (
    <Grid container>
      <Grid item xs={12}>
        {primaryContext.primaryContextListFetchStatus === ApiStatus.ERROR ? (
          <Dialog
            open
            backButton={false}
            dialogActions={
              <Grid container justifyContent="flex-end" className={classes.actionGrid}>
                <Button
                  onClick={async () => {
                    await sendAIMSHeartbeat({
                      logoutTime: dayjs(),
                      comment: { location: 'Home' },
                    });
                    history.push('/logout');
                  }}
                  variant="contained"
                  color="primary"
                  className="logoutButton"
                  noMinHeight
                >
                  Logout
                </Button>
              </Grid>
            }
            maxWidth="xs"
            noMinHeight
          >
            <Grid className={classes.dialogContent}>
              <Grid>
                <Grid container xs={12}>
                  <Grid item xs={1}>
                    <Icons.InfoFeather color="error" />
                  </Grid>
                  <Grid item xs={11}>
                    <Typography className={classes.text}>
                      You are not authorized to access this application
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Dialog>
        ) : (
          <SiteDisciplinePopUp open={true} onClose={() => {}} />
        )}
      </Grid>
    </Grid>
  );
};

export default observer(Home);
